import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, PackageIcon } from 'lucide-react';
import { modules } from '../data/content';
import { Eyebrow, Mark, SectionLead, SectionTitle } from './ui/Section';
const collapseTransition = {
  duration: 0.22,
  ease: [0.23, 1, 0.32, 1] as const
};
export function Modules() {
  const [open, setOpen] = useState(0);
  return <section className="mx-auto max-w-4xl px-4 py-12 md:py-16" data-id="element-225" data-mp="146o3mzjwzcpg">
      <Eyebrow data-id="element-226" data-mp="187hpzohpkjg8">
        <span className="inline-flex items-center gap-2" data-id="element-227" data-mp="18782c7k4yodp">
          <PackageIcon className="h-4 w-4" data-id="element-228" data-mp="187rf79uximkv" /> Qué incluye el sistema
        </span>
      </Eyebrow>
      <SectionTitle data-id="element-229" data-mp="1d59hihefy3jw">
        5 tomos · 5 bonos · <span className="text-sky-600" data-id="element-230" data-mp="1i66xqofw4nir">50 proyectos</span>
      </SectionTitle>
      <SectionLead data-id="element-231" data-mp="1i3b2x8zcaeyj">
        No recibís solamente fotografías de muebles para inspirarte. Recibís proyectos organizados
        para saber:
      </SectionLead>
      <p className="mx-auto mt-3 max-w-2xl text-center text-base font-black text-slate-900 md:text-xl" data-id="element-232" data-mp="2tjj9dlhw6afh">
        <Mark data-id="element-233" data-mp="1ujfe3ryl7po">qué piezas necesitás, cuánto deben medir y cómo unirlas.</Mark>
      </p>

      <div className="mt-8 space-y-3" data-id="element-234" data-mp="3u06txeflluje">
        {modules.map((mod, index) => <div key={mod.name} className={`overflow-hidden rounded-2xl border bg-white transition-colors duration-150 ease-out ${open === index ? 'border-sky-600 shadow-lg shadow-slate-200' : 'border-slate-200'}`} data-id="element-235" data-mp="3oyzk79twala3" data-mpi={index}>
            <button className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6" aria-expanded={open === index} onClick={() => setOpen(open === index ? -1 : index)} data-id="element-236" data-mp="3ab4qbq45iavf">
              <span className="flex items-start gap-3" data-id="element-237" data-mp="31brg2v87di9n">
                <span className="text-2xl leading-none" data-id="element-238" data-mp="2wbmxmznqidgs">{mod.icon}</span>
                <span data-id="element-239" data-mp="2wcy08w5g1f6b">
                  <b className="block text-sm font-black uppercase text-slate-900 md:text-base" data-id="element-240" data-mp="2rbifl576haog">
                    {mod.name}
                  </b>
                  <small className="block text-xs font-bold leading-snug text-sky-700 md:text-sm" data-id="element-241" data-mp="2hn3dlkm4ia6u">
                    {mod.period}
                  </small>
                </span>
              </span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-sky-600 transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} data-id="element-242" data-mp="28pjbyakcmbvp" />
            </button>
            <AnimatePresence initial={false} data-id="element-243" data-mp="30gz7wv7spayl">
              {open === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={collapseTransition} data-id="element-244" data-mp="35dhb3qnh918t">
                  <div className="border-t border-slate-200 px-5 py-4 md:px-6" data-id="element-245" data-mp="3jd8ktf6ynvh0">
                    <p className="text-[11px] font-extrabold uppercase tracking-wide text-slate-500" data-id="element-246" data-mp="3o48du9cylte8">
                      Incluye:
                    </p>
                    <ul className="mt-2 grid gap-3 text-sm text-slate-600 sm:grid-cols-2" data-id="element-247" data-mp="1cnwz5bu03d09">
                      {mod.content.map(([title, detail]) => <li key={title} className="flex gap-2" data-id="element-248" data-mp="1mfud2qce8j2o">
                          <span className="font-black text-sky-600" data-id="element-249" data-mp="1mh5isvpeg0wf">→</span>
                          <span data-id="element-250" data-mp="1hgq3vzpgylcc">
                            <b className="block font-extrabold text-slate-900" data-id="element-251" data-mp="tqni21c5ebm6">{title}</b>
                            {detail && <span className="font-semibold" data-id="element-252" data-mp="orkd0gw645e7">{detail}</span>}
                          </span>
                        </li>)}
                    </ul>
                    {mod.note && <p className="mt-3 text-sm font-semibold text-slate-600" data-id="element-253" data-mp="yp74s3ykfrfl">{mod.note}</p>}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}